export default "__VITE_ASSET__BurMc0Wc__"